import fetch from '@/utils/fetch';


// 查询学校类型统计
export function getTrainTypeStatisticalList() {

    return fetch({
        url: 'structure/throughTrain/getTrainTypeStatisticalList',
        method: 'get'
    });

}



// WEBPACK FOOTER //
// ./src/api/accounting/accounting.js